module.exports = __webpack_public_path__ + "img/t2.52cc4e70.png";